<script>
import axios from "axios";
import moment from "moment";
import errorCommons from "../mixins/mixErrorCommons.vue";
import { toast } from "vue3-toastify";


export default {
  mixins: [errorCommons],
  data() {
    return {
      arrayIvaForDefault: ["10.50", "21.00"],
      availableVatConditions: [
        {
          name: "Responsable Inscripto",
          id: 1,
        },
        {
          name: "Exento",
          id: 2,
        },
        {
          name: "Monotributo",
          id: 3,
        },
      ],
      tabsFilter: [
        {
          id: 1,
          title: `Hoy`,
          param: "Today",
          show: this.$store.getAuthUser || localStorage['currentUserData'],
          canBeHide: true,
        },
        {
          id: 2,
          title: "Ayer",
          param: "Yesterday",
          show: false,
          canBeHide: true,
        },
        {
          id: 3,
          title: "Semana",
          param: "Week",
          show:  this.$store.getAuthUser || localStorage['currentUserData'],
          canBeHide: true,
        },
        {
          id: 4,
          title: "Mes",
          param: "Month",
          show:  this.$store.getAuthUser || localStorage['currentUserData'],
          canBeHide: true,
        },
        {
          id: 5,
          title: "Todos",
          param: "All",
          show: false,
          canBeHide: true,
        },

        {
          id: 6,
          title: "Personalizado",
          param: "ConfigurablePeriod",
          show: false,
        },
        {
          id: 7,
          title: "Caja en curso",
          param: "CurrentCashBox",
          show:  this.$store.getAuthUser || localStorage['currentUserData'],
          canBeHide: true,
        },
        {
          id: 8,
          title: "Caja anterior",
          param: "PreviusCashBox",
          show:  this.$store.getAuthUser || localStorage['currentUserData'],
          canBeHide: true,
        },
      ],
      excludedOfflineRoutes: ['/dashboard/indexV2', '/dashboard/reportPDV', '/productspdv'],
      isOnline: navigator.onLine,
    };
  },
  mounted() {
    // INICIALIZAR NICESCROLL
    /* $('html').niceScroll(
        {cursorwidth: '9px', zindex: '9999', cursorborder: '0px', cursorborderradius: '0px', cursorcolor: '#24a5d3'}
      ) */
    // MODALS
    //$(".modal").modal();
    /* eslint-disable */
    var modal = document.querySelectorAll(".modal");
    M.Modal.init(modal);

    // DROPDOWN
    //$(".dropdown-trigger").dropdown();
    var dropdown = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(dropdown);
    // TOOLTIP
    //$(".tooltipped").tooltip();
    var tooltip = document.querySelectorAll(".tooltipped");
    M.Tooltip.init(tooltip);
    /* eslint-enable */
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  computed: {
    /* eslint-disable */
    appTitle() {
      switch (process.env.VUE_APP_INSTANCE_CODE) {
        case "PROVENTAS":
          return "Proventas";
        case "ENERGY_POS_SV":
          return "Energy POS";
        default:
          return "Bistro";
      }
    },
    isOffLine() {  
      return !navigator.onLine ? true : false
    },
    isMerchantEnabled(){
            return this.$store.getMerchantStatus
        },
    hasFiscalDataChangedAR() {
      if (this.previousFiscalKey !== this.currentFiscalKey) return true;
      if (this.previousLegalName !== this.currentLegalName) return true;
      if (this.previousLegalAddress !== this.currentLegalAddress) return true;
      if (this.previousPosId !== this.currentPosId) return true;
      if (this.previousVatCondition !== this.currentVatCondition) return true;
      if (this.previousGrossIncome !== this.currentGrossIncome) return true;
      if (this.previousActivitiesStartDate !== this.currentActivitiesStartDate)
        return true;
      if (this.previousCustomFooterEnabled !== this.currentCustomFooterEnabled) return true;
      if (this.previousCustomFooterText !== this.currentCustomFooterText) return true;
      if (this.previousFiscalLegendOption !== this.currentFiscalLegendOption) return true;
      if (this.previousFiscalLegendCbu !== this.currentFiscalLegendCbu) return true;
      else return false;
    },
    // Detecta si SOLO cambiaron los ajustes que van por endpoint propio (texto personalizado
    // y leyenda fiscal), en cuyo caso no hay que enviar nada al canal de facturación.
    hasOnlyTicketConfigChangedAR() {
      const coreFieldsChanged = (
        this.previousFiscalKey !== this.currentFiscalKey ||
        this.previousLegalName !== this.currentLegalName ||
        this.previousLegalAddress !== this.currentLegalAddress ||
        this.previousPosId !== this.currentPosId ||
        this.previousVatCondition !== this.currentVatCondition ||
        this.previousGrossIncome !== this.currentGrossIncome ||
        this.previousActivitiesStartDate !== this.currentActivitiesStartDate
      );

      const ticketConfigChanged = (
        this.previousCustomFooterEnabled !== this.currentCustomFooterEnabled ||
        this.previousCustomFooterText !== this.currentCustomFooterText ||
        this.previousFiscalLegendOption !== this.currentFiscalLegendOption ||
        this.previousFiscalLegendCbu !== this.currentFiscalLegendCbu
      );

      // Solo cambió configuración de ticket si: hay cambios en ella PERO NO en campos core
      return ticketConfigChanged && !coreFieldsChanged;
    },
    hasFiscalDataChangedMX() {
      if (this.previousFiscalKey !== this.currentFiscalKey) return true;
      if (this.previousLegalName !== this.currentLegalName) return true;
      if (this.previousTaxRegime !== this.currentTaxRegime) return true;
      if (this.previousZipCode !== this.currentZipCode) return true;
      else return false;
    },
    currentTaxRegime() {
      if (!this.currentValues) return null;
      return this.currentValues.fiscalData.taxRegime || "N/A";
    },
    previousTaxRegime() {
      if (!this.previousValues) return null;
      return this.previousValues.fiscalData.taxRegime || "N/A";
    },
    currentZipCode() {
      if (!this.currentValues) return null;
      return this.currentValues.fiscalData.zipCode || "N/A";
    },
    previousZipCode() {
      if (!this.previousValues) return null;
      return this.previousValues.fiscalData.zipCode || "N/A";
    },
    currentFiscalKey() {
      if (!this.currentValues) return null;
      return this.currentValues.fiscalData.fiscalKey || "N/A";
    },
    previousFiscalKey() {
      if (!this.previousValues) return null;
      return this.previousValues.fiscalData.fiscalKey || "N/A";
    },
    currentPosId() {
      if (!this.currentValues) return null;
      return this.currentValues.fiscalData.posId || "N/A";
    },
    previousPosId() {
      if (!this.previousValues) return null;
      return this.previousValues.fiscalData.posId || "N/A";
    },
    currentVatCondition() {
      if (!this.currentValues) return null;
      if (this.currentValues.fiscalData.vatCondition) {
        return this.availableVatConditions.filter(
          (x) => x.id === this.currentValues.fiscalData.vatCondition
        )[0].name;
      } else return "N/A";
    },
    previousVatCondition() {
      if (!this.previousValues) return null;
      if (this.previousValues.fiscalData.vatCondition) {
        return this.availableVatConditions.filter(
          (x) => x.id === this.previousValues.fiscalData.vatCondition
        )[0].name;
      } else return "N/A";
    },
    currentLegalName() {
      if (!this.currentValues) return null;
      return this.currentValues.fiscalData.legalName || "N/A";
    },
    previousLegalName() {
      if (!this.previousValues) return null;
      return this.previousValues.fiscalData.legalName || "N/A";
    },
    currentLegalAddress() {
      if (!this.currentValues) return null;
      return this.currentValues.fiscalData.legalAddress || "N/A";
    },
    previousLegalAddress() {
      if (!this.previousValues) return null;
      return this.previousValues.fiscalData.legalAddress || "N/A";
    },
    currentGrossIncome() {
      if (!this.currentValues) return null;
      return this.currentValues.fiscalData.grossIncome || "N/A";
    },
    previousGrossIncome() {
      if (!this.previousValues) return null;
      return this.previousValues.fiscalData.grossIncome || "N/A";
    },
    currentActivitiesStartDate() {
      if (!this.currentValues) return null;
      return this.currentValues.fiscalData.activitiesStartDate || "N/A";
    },
    previousActivitiesStartDate() {
      if (!this.previousValues) return null;
      return this.previousValues.fiscalData.activitiesStartDate || "N/A";
    },
    // Computed properties para CustomFooter JSON
    currentCustomFooterData() {
      if (!this.currentValues) return { value: 0, label: '' };
      return this.parseCustomFooter(this.currentValues.fiscalData.CustomFooter);
    },
    previousCustomFooterData() {
      if (!this.previousValues) return { value: 0, label: '' };
      return this.parseCustomFooter(this.previousValues.fiscalData.CustomFooter);
    },
    currentCustomFooterEnabled() {
      return this.currentCustomFooterData.value === 1;
    },
    previousCustomFooterEnabled() {
      return this.previousCustomFooterData.value === 1;
    },
    currentCustomFooterText() {
      return this.currentCustomFooterData.label || '';
    },
    previousCustomFooterText() {
      return this.previousCustomFooterData.label || '';
    },
    // BEVO-18 (RG 5762): leyenda fiscal de factura A
    currentFiscalLegendData() {
      if (!this.currentValues) return { value: 0, label: '' };
      // El backend serializa en camelCase; el store guarda la variante con mayúscula.
      return this.parseFiscalLegend(
        this.currentValues.fiscalData.FiscalLegend ?? this.currentValues.fiscalData.fiscalLegend
      );
    },
    previousFiscalLegendData() {
      if (!this.previousValues) return { value: 0, label: '' };
      return this.parseFiscalLegend(
        this.previousValues.fiscalData.FiscalLegend ?? this.previousValues.fiscalData.fiscalLegend
      );
    },
    currentFiscalLegendOption() {
      return this.currentFiscalLegendData.value;
    },
    previousFiscalLegendOption() {
      return this.previousFiscalLegendData.value;
    },
    currentFiscalLegendCbu() {
      return this.currentFiscalLegendData.label || '';
    },
    previousFiscalLegendCbu() {
      return this.previousFiscalLegendData.label || '';
    },
    currentValues() {
      return this.$store.getProfileShops.filter(
        (x) => x.code == this.shopCode
      )[0];
    },
    previousValues() {
      return this.$store.getOriginalProfileShops.filter(
        (x) => x.code == this.shopCode
      )[0];
    },
    mobile() {
      return this.$store.getMobile;
    },
    isMX() {
      switch (process.env.VUE_APP_INSTANCE_CODE) {
        case "MX":
          return true;
        default:
          return false;
      }
    },
    showBillingPage() {
      return this.$store.getAuthUser?.hasToShowBillingPage ?? false;
    },
    getProductActionSelected() {
      return this.$store.getProductActionSelected;
    },
    isProviderActionSelected() {
      return this.$store.getProviderActionSelected === "provider";
    },
    isProviderBillActionSelected() {
      return this.$store.getProviderActionSelected === "bills";
    },
    isPurchaseOrdersActionSelected() {
        return this.$store.getProviderActionSelected === "purchaseOrders";
    },
    isProductActionSelected() {
      return this.$store.getProductActionSelected === "product";
    },
    showMerchantSelectionFilter() {
      return this.$store.getShowMerchantSelectionFilter;
    },
    showProductListSelectionFilter() {
      return this.$store.getShowProductListSelectionFilter;
    },
    showPDVListSelectionFilter() {
      return this.$store.getShowPDVListSelectionFilter;
    },
    showProviderListSelectionFilter() {
      return this.$store.getShowProviderListSelectionFilter;
    },
    showMyPaymentsListSelectionFilter() {
      return this.$store.getShowMyPaymentsListSelectionFilter;
    },
    showMyAccountListSelectionFilter() {
      return this.$store.getShowMyAccountListSelectionFilter;
    },
    showMenuEngineeringListSelectionFilter() {
      return this.$store.getShowMenuEngineeringListSelectionFilter;
    },
    showClientListSelectionFilter() {
      return this.$store.getShowClientListSelectionFilter;
    },
    showUserListSelectionFilter() {
      return this.$store.getShowUserListSelectionFilter;
    },
    showSettingListSelectionFilter() {
      return this.$store.getShowSettingListSelectionFilter;
    },
    /* eslint-enable */
    isOnLine() {
      return navigator.onLine;
    },
    isOnIntegrationsPage() {
      return this.$route.path === '/dashboard/integrations';
    },
    isOnProductsPDVPage() {
      return this.$route.path === '/productspdv';
    },
  },
  methods: {
    // Función auxiliar para parsear CustomFooter JSON
    parseCustomFooter(customFooterValue) {
      if (!customFooterValue) {
        return { value: 0, label: '' };
      }

      try {
        if (typeof customFooterValue === 'object') {
          return customFooterValue;
        }
        return JSON.parse(customFooterValue);
      } catch (error) {
        console.error('Error parsing CustomFooter JSON:', error);
        return { value: 0, label: '' };
      }
    },
    // BEVO-18 (RG 5762): parsea FiscalLegend JSON {"value":0|1|2,"label":"<CBU>"}
    parseFiscalLegend(fiscalLegendValue) {
      if (!fiscalLegendValue) {
        return { value: 0, label: '' };
      }

      try {
        const parsed = typeof fiscalLegendValue === 'object'
          ? fiscalLegendValue
          : JSON.parse(fiscalLegendValue);
        const value = Number(parsed.value);
        if (![0, 1, 2].includes(value)) {
          return { value: 0, label: '' };
        }
        return { value, label: value === 2 ? (parsed.label || '') : '' };
      } catch (error) {
        console.error('Error parsing FiscalLegend JSON:', error);
        return { value: 0, label: '' };
      }
    },
    updateOnlineStatus() {
      this.isOnline = navigator.onLine;
    },
    async pageChangeHandle(value) {
      switch (value) {
        case "next":
          this.currentPage += 1;
          break;
        case "previous":
          this.currentPage -= 1;
          break;
        default:
          this.currentPage = value;
      }
      this.params["CurrentPage"] = this.currentPage;
      this.getData();  
    },
    getTaxValues() {
      if (
        this.$store.getAuthUser.taxValues === null ||
        this.$store.getAuthUser.taxValues === undefined
      ) {
        return this.arrayIvaForDefault;
      }
      
      let taxValues = this.$store.getAuthUser.taxValues.split(",")
      if (process.env.VUE_APP_INSTANCE_CODE == "AR") {
        taxValues.push("Exento")
        taxValues.push("No Gravado")
      }
      return taxValues;
    },
    checkMerchantStatus(){
            if(!navigator.onLine) return 
            axios
            .get(`/api/dashboardV2`)
            .then((res) => {
                if(res.data.responseCode === -1){
                    toast.error(res.data.responseMessage)
                    this.$store.setMerchantStatus(false)
                }
            })
            .catch((err) => {
            console.error(err.response);
            });
        },
    getIEPSTaxValues() {
      return [0, 3, 6, 7, 8, 9, 25, 26.5, 30, 30.4, 50, 53, 160];
    },
    toggleMerchantSelectorByLabel(label) {
      if (label == "showMerchantSelectionFilter")
        this.$store.setShowMerchantSelectionFilter(true);
      else this.$store.setShowMerchantSelectionFilter(false);

      if (label == "showProductListSelectionFilter")
        this.$store.setShowProductListSelectionFilter(true);
      else this.$store.setShowProductListSelectionFilter(false);

      if (label == "showProviderListSelectionFilter")
        this.$store.setShowProviderListSelectionFilter(true);
      else this.$store.setShowProviderListSelectionFilter(false);

      if (label == "showMenuEngineeringListSelectionFilter")
        this.$store.setShowMenuEngineeringListSelectionFilter(true);
      else this.$store.setShowMenuEngineeringListSelectionFilter(false);

      if (label == "showClientListSelectionFilter")
        this.$store.setShowClientListSelectionFilter(true);
      else this.$store.setShowClientListSelectionFilter(false);

      if (label == "showUserListSelectionFilter")
        this.$store.setShowUserListSelectionFilter(true);
      else this.$store.setShowUserListSelectionFilter(false);

      if (label == "showPDVListSelectionFilter")
        this.$store.setShowPDVListSelectionFilter(true);
      else this.$store.setShowPDVListSelectionFilter(false);

      if (label == "showSettingListSelectionFilter")
        this.$store.setShowSettingListSelectionFilter(true);
      else this.$store.setShowSettingListSelectionFilter(false);

      if (label == "showMyPaymentsListSelectionFilter")
        this.$store.setShowMyPaymentsListSelectionFilter(true);
      else this.$store.setShowMyPaymentsListSelectionFilter(false);

      if (label == "showMyAccountListSelectionFilter")
        this.$store.setShowMyAccountListSelectionFilter(true);
      else this.$store.setShowMyAccountListSelectionFilter(false);
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne === "" && dateTwo === "") {
        formattedDates = "Seleccione fecha";
      } else {
        if (dateOne) {
          formattedDates = moment(dateOne).utcOffset(0).format("lll");
        }
        if (dateTwo) {
          formattedDates += " - " + moment(dateTwo).utcOffset(0).format("lll");
        }
      }
      return this.$store.updateDate(formattedDates);
    },
    logout() {
      if(this.isOffLine){
        this.deleteSession()
      } else{
        axios
          .get("/api/auth/logout") 
          .then(() => {
            this.deleteSession()  
        });
      }
    },
    deleteSession(){
      navigator.serviceWorker.controller?.postMessage({ action: 'clear-cache' });
      this.resetUser();
      this.setAutomaticLogin(false);
      this.resetPeriodSelection();
      location.href = "/login";
    },
    getKnowledgeBaseUrl() {
      const { EXTERNAL_LINKS } = require('../constants/externalLinks');
      switch (process.env.VUE_APP_INSTANCE_CODE) {
        case "MX":
          return EXTERNAL_LINKS.KNOWLEDGE_BASE_MX;
        case "AR":
          return EXTERNAL_LINKS.KNOWLEDGE_BASE_AR;
        case "ENERGY_POS_SV": ///FIXME Falta definir la URL
        default:
          return EXTERNAL_LINKS.KNOWLEDGE_BASE_DEFAULT;
      }
    },
    getHelpDeskWhatsapp(message = null) {
      const phoneNumber = process.env.VUE_APP_INSTANCE_CODE === "MX"
        ? "5491127460863"
        : "5491127398593";
      const url = `https://wa.me/${phoneNumber}`;

      return message ? `${url}?text=${encodeURIComponent(message)}` : url;
    },
    setUserData(userData) {
      localStorage["userData"] = JSON.stringify(userData);
    },
    setMerchantTags(merchantTags) {
      localStorage["merchantTags"] = JSON.stringify(merchantTags);
    },
    async getOneOption(optionId, shopCode){
      const params = {
        optionId,
        shopCode
      }
      this.$store.initLoading(this)
      const option = await axios.get("/api/advancedProducts/getOneOption", {params})
      this.$store.finishLoading(this)
      return option.data
    },
    async getContextFromBackendReviewsType(){
      this.$store.initLoading(this)
      try {
        const res = await axios.get("/api/productsV2/getContextFromBackendReviewsType")
        this.$store.finishLoading(this)
        return res.data.reviewTypes
      } catch (error) {
        this.$store.errorLoading(this)
        console.error("Error en getContextFromBackendReviewsType:", error)
        return []
      }
    },
    getMerchantTags() {
      const jsonMerchantTags = localStorage["merchantTags"];
      if (jsonMerchantTags) {
        return JSON.parse(jsonMerchantTags)?.merchantTags;
      }
      return null;
    },
    setUser() {
      localStorage["loggedUser"] = true;
    },
    resetUser() {
      localStorage["loggedUser"] = false;
      localStorage["merchantTags"] = null;
    },
    handleUnauthorizedAccess(){
        this.showError("No tiene acceso a este módulo");
        setTimeout(() => {
            this.logout();
        }, 1500);
    },
    
    isUserLoggedIn() {
      const result = localStorage["loggedUser"] === "true";
      if (result) {
        var merchantTags = this.getMerchantTags();
        if (!merchantTags) {
          return false;
        }
        this.$store.SET_MERCHANT_TAGS(merchantTags);
        const selectedMerhants = merchantTags.filter(
          (obj) => obj.selected === true
        );
        this.$store.resetSelectedMerchants();
        selectedMerhants.forEach((pdv) => this.$store.selectMerchant(pdv));
      }

      return result;
    },
    formatCurrency(value) {
      return (
        value?.toLocaleString("es-AR", {
          style: "currency",
          currency: "ARS",
        }) || "0"
      );
    },
    setAutomaticLogin(bool) {
      localStorage["isAutomaticLogin"] = bool;
    },
    isAutomaticLogin() {
      return localStorage["isAutomaticLogin"] === "true";
    },
    setPeriodSelection(period) {
      localStorage["periodSelection"] = JSON.stringify(period);
    },
    resetPeriodSelection() {
      // localStorage['periodSelection'] = '{"id":1,"title":"Hoy","param":"Today","show":true,"canBeHide":true}'
      localStorage["periodSelection"] =
        '{"id":7,"title":"Caja en curso","param":"CurrentCashBox","show":true,"canBeHide":true}';
    },
    getPeriodSelectionFromLocalStorage() {
      if (!localStorage["periodSelection"]) return null;
      try {
        return JSON.parse(localStorage["periodSelection"]);
      } catch (e) {
        return null;
      }
    },
    setEditStockMovementList(value) {
      if (value === null || value === undefined) {
        localStorage["editStockMovementList"] = null;
        this.$store.setStockMovements(null);
      } else {
        localStorage["editStockMovementList"] = JSON.stringify(value);
        this.$store.setStockMovements(value);
      }
    },
    getStockMovementList() {
      const string = localStorage["editStockMovementList"];
      if (string === undefined) return "";
      if (string === null || string === "") return string;

      var obj = JSON.parse(string);

      if (!obj.config) return "";

      return obj;
    },
    /**
     * Función para validar inputs numéricos
     * Maneja tanto la prevención de caracteres inválidos como la corrección de valores
     * @param {Event} event - El evento del input (keydown, input, blur)
     * @param {number} minValue - Valor mínimo permitido (opcional)
     * @param {number} maxValue - Valor máximo permitido (opcional)
     */
    validateNumericInput(event, minValue = null, maxValue = null) {
      if (event.type === 'keydown') {
        // Lógica para prevenir caracteres inválidos
        const char = event.key;
        const currentValue = event.target.value;
        const newValue = currentValue + char;
        
        // Permitir teclas de control
        if ([
          'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
        ].includes(char)) {
          return true;
        }
        
        // Solo permitir dígitos del 0-9
        if (!/^[0-9]$/.test(char)) {
          event.preventDefault();
          return false;
        }
        
        // Si minValue es mayor a 0, no permitir que el primer carácter sea 0
        if (minValue !== null && minValue > 0 && currentValue === '' && char === '0') {
          event.preventDefault();
          return false;
        }
        
        // Validar que el nuevo valor sea un número entero válido
        if (newValue && !Number.isInteger(parseFloat(newValue))) {
          event.preventDefault();
          return false;
        }
        
        // Validar valor mínimo
        if (minValue !== null && newValue && parseInt(newValue) < minValue) {
          event.preventDefault();
          return false;
        }
        
        // Validar valor máximo
        if (maxValue !== null && newValue && parseInt(newValue) > maxValue) {
          event.preventDefault();
          return false;
        }
        
        return true;
      } else if (event.type === 'input' || event.type === 'blur') {
        // Lógica para corregir valores ya ingresados
        const input = event.target;
        let value = parseInt(input.value);
        let correctedValue = null;
        
        // Si el valor no es un número válido, no hacer nada
        if (isNaN(value) || input.value === '') {
          return;
        }
        
        // Validar valor mínimo
        if (minValue !== null && value < minValue) {
          correctedValue = minValue;
        }
        
        // Validar valor máximo
        if (maxValue !== null && value > maxValue) {
          correctedValue = maxValue;
        }
        
        // Solo actualizar si el valor necesita corrección
        if (correctedValue !== null && correctedValue !== value) {
          // Usar setTimeout para evitar bucles infinitos
          setTimeout(() => {
            input.value = correctedValue.toString();
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }, 0);
        }
      }
    },
  },
};
</script>
